export default "__VITE_ASSET__B1L2BCIY__"